import React from 'react';
import { useIntl } from 'react-intl';

import { lifecycleStateMessages } from '../messages';
import type { RegenerativeMedicineLifecycleState } from '../types';
import { StatusBadge, type StatusBadgeVariant } from './StatusBadge';

const lifecycleVariant = (
  state: RegenerativeMedicineLifecycleState,
): StatusBadgeVariant => {
  switch (state) {
    case 'not_assessed':
      return 'notAssessed';
    case 'interest_flagged':
    case 'procedure_documented':
    case 'revenue_captured':
      return 'blocked';
    case 'post_procedure_followups':
    case 'consent_complete':
    case 'consult_completed':
      return 'complete';
    default:
      return 'inProgress';
  }
};

type LifecyclePillProps = {
  state: RegenerativeMedicineLifecycleState;
};

export const LifecyclePill: React.FC<LifecyclePillProps> = ({ state }) => {
  const { formatMessage } = useIntl();

  return (
    <StatusBadge
      variant={lifecycleVariant(state)}
      label={formatMessage(lifecycleStateMessages[state])}
    />
  );
};
